// 리워드 영상광고 골격 — @capacitor-community/admob (Android).
// 지금은 구글 공식 "테스트 광고 ID"로 골격만 구성. 실제 AdMob ID는 추후 교체.
// 웹에서는 available=false → UI가 "앱에서 이용 가능" 비활성 상태로 폴백.
import { isNative, isAndroid } from "./platform";

// 구글 공식 테스트 광고 단위 ID (Android 리워드). 실제 ID로 교체 예정.
const TEST_REWARD_AD_ID = "ca-app-pub-3940256099942544/5224354917";

let initialized = false;

const loadAdMob = async () => {
  try {
    return await import("@capacitor-community/admob");
  } catch (e) {
    return null;
  }
};

export const rewardAdAvailable = () => isNative() && isAndroid();

export const initRewardAds = async () => {
  if (!rewardAdAvailable() || initialized) return;
  const mod = await loadAdMob();
  if (!mod) return;
  try {
    await mod.AdMob.initialize({ initializeForTesting: true });
    initialized = true;
  } catch (e) { /* noop */ }
};

// 광고를 준비/표시하고 시청 완료(보상) 여부를 boolean 으로 반환.
// options(선택): { userId, customData } — SSV(서버검증) 강제 시 nonce/userId 전달용.
//   전달하지 않으면(기본) 기존 동작 100% 유지(회귀 0).
export const showRewardAd = async (options = {}) => {
  if (!rewardAdAvailable()) return false;
  const mod = await loadAdMob();
  if (!mod) return false;
  const { AdMob, RewardAdPluginEvents } = mod;
  await initRewardAds();

  // SSV 옵션 자리(플래그 false면 useSteps가 넘기지 않아 비활성). userId=구글 SSV user_id, customData=nonce.
  const prepareOpts = { adId: TEST_REWARD_AD_ID };
  if (options && (options.userId || options.customData)) {
    prepareOpts.ssv = {};
    if (options.userId) prepareOpts.ssv.userId = String(options.userId);
    if (options.customData) prepareOpts.ssv.customData = String(options.customData);
  }

  return new Promise(async (resolve) => {
    let rewarded = false;
    let rewardedListener = null;
    let dismissListener = null;
    const cleanup = async () => {
      try { if (rewardedListener) await rewardedListener.remove(); } catch (e) { /* noop */ }
      try { if (dismissListener) await dismissListener.remove(); } catch (e) { /* noop */ }
    };
    try {
      rewardedListener = await AdMob.addListener(RewardAdPluginEvents.Rewarded, () => { rewarded = true; });
      dismissListener = await AdMob.addListener(RewardAdPluginEvents.Dismissed, async () => {
        await cleanup();
        resolve(rewarded);
      });
      await AdMob.prepareRewardVideoAd(prepareOpts);
      const item = await AdMob.showRewardVideoAd();
      if (item && (item.amount || item.type)) rewarded = true;
      // Dismissed 이벤트가 오지 않는 환경 대비 폴백
      setTimeout(async () => { await cleanup(); resolve(rewarded); }, 1500);
    } catch (e) {
      await cleanup();
      resolve(false);
    }
  });
};
